import styled from 'styled-components';
import { fontSettings, transition } from '../../../../../../styles';

export const EmailLoginSuggestion = styled.div`
  margin-top: 12px;
  padding: 8px;
  background-color: ${({ theme }): string => theme.COLOR.PRIMARY['100']};
  border-radius: 8px;

  ${({ theme }): string => fontSettings(theme.FONT.SIZE_13, theme.FONT)};
  font-weight: 400;
`;

export const EmailLoginSuggestionValue = styled.a`
  color: ${({ theme }): string => theme.COLOR.PRIMARY['500']};
  cursor: pointer;
  opacity: 1;
  ${transition('opacity')};

  &:hover {
    opacity: 0.84;
    text-decoration: underline;
  }
`;
